import { Tooltip, Chip, Box } from "@mui/material";
import PropTypes from "prop-types";

function StaffingAndWorkload({ data, t }) {
  console.log("Data In Staffing and Workload", data);
  // --- Staffing Logic ---
  let staffingStatus = null; // no status by default
  let diff = 0;
  const mr = data?.manpowerReq || null;
  let tooltipMessage = null;

  //1) Calculate manpower depending on revenueGenerator ---
  let workloadStatus = "balanced";
  let workloadPct = null;

  if (data.manpowerReq) {
    const manpowerReq = data.manpowerReq; // This is the object containing diff, utilization, etc.
    const fte = data.isScenario
      ? (data.numberOfEmployees ?? 0) // ⚡ scenario → use numberOfEmployees
      : (data.fte ?? 0);

    // --- 1. Staffing Status (Using direct 'diff' from backend) ---
    // Use the diff already calculated: diff = fte - requiredFTE
    diff = manpowerReq.diff;

    if (typeof diff === "number" && !isNaN(diff)) {
      if (diff < 0) {
        staffingStatus = "understaffed";
      } else if (diff > 0) {
        // Maintaining your specific rule: if only 1 person, call it balanced
        staffingStatus = fte === 1 ? "balanced" : "overstaffed";
      } else {
        staffingStatus = "balanced";
      }
    }

    // --- 2. Workload Logic (Using direct 'utilization' from backend) ---
    // Note: We renamed this to 'utilization' in the Java logic
    // workloadPct = manpowerReq.utilization;
    workloadPct = (manpowerReq.averageWorkloadForEmps ?? 0) * 100;

    if (typeof workloadPct === "number" && !isNaN(workloadPct) && workloadPct > 0) {
      if (workloadPct > 115) {
        workloadStatus = "overworked";
      } else if (workloadPct < 90) {
        workloadStatus = "underworked";
      }
    }
  }

  // --- Tooltip Mapping ---
  if (staffingStatus && workloadStatus) {
    if (staffingStatus == "balanced" && workloadStatus == "balanced") {
      tooltipMessage = t("tooltip.stable");
    } else {
      tooltipMessage = t(`tooltip.${staffingStatus}_${workloadStatus}`);
    }
  }

  return (
    <Tooltip
      title={tooltipMessage || ""}
      placement="top"
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              boundary: "viewport",
            },
          },
        ],
      }}
    >
      <Box display="flex" justifyContent="center" gap={0.5} mt={0.5}>
        {/* Staffing Chip */}
        {staffingStatus !== null && (
          <Chip
            label={t(`customNode.staffing.${staffingStatus}`, {
              count: Math.abs(diff),
            })}
            color={
              staffingStatus === "understaffed"
                ? "error"
                : staffingStatus === "overstaffed"
                  ? "warning"
                  : "success"
            }
            size="small"
            sx={{
              fontSize: "8px",
              height: 16,
              px: 0.5,
              whiteSpace: "nowrap",
              ...(staffingStatus === "balanced" && {
                backgroundColor: "#108092 !important",
                color: "#fff !important",
              }),
            }}
          />
        )}

        {/* Workload Chip */}
        {workloadPct !== null && workloadPct > 0 && workloadStatus && (
          <Chip
            label={t(`customNode.workload.${workloadStatus}`, {
              percent: workloadPct.toFixed(0),
            })}
            color={
              workloadStatus === "overworked"
                ? "error"
                : workloadStatus === "underworked"
                  ? "warning"
                  : "success"
            }
            size="small"
            sx={{
              fontSize: "8px",
              height: 16,
              px: 0.5,
              whiteSpace: "nowrap",
              ...(workloadStatus === "balanced" && {
                backgroundColor: "#108092 !important",
                color: "#fff !important",
              }),
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
}

StaffingAndWorkload.propTypes = {
  data: PropTypes.object.isRequired,
  t: PropTypes.object.isRequired,
  refreshKey: PropTypes.number,
};

export default StaffingAndWorkload;
